// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selector-main-page-wrapper {
    display: flex;
    gap: 4px;
    align-items: end;
    user-select: none;
    background-color: #ffffff;
}

.selector-main-page-wrapper p {
    padding-bottom: 3px;
    color: #8B8B8B;
}

.selector-main-page-wrapper .selector-main-page-label {
    display: block;
    font-size: 32px;
    color: #005c32;
    font-weight: 800;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/selector/Layouts/MainPage/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB","sourcesContent":[".selector-main-page-wrapper {\n    display: flex;\n    gap: 4px;\n    align-items: end;\n    user-select: none;\n    background-color: #ffffff;\n}\n\n.selector-main-page-wrapper p {\n    padding-bottom: 3px;\n    color: #8B8B8B;\n}\n\n.selector-main-page-wrapper .selector-main-page-label {\n    display: block;\n    font-size: 32px;\n    color: #005c32;\n    font-weight: 800;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
